<script lang="ts">export let backgroundColor = "";
export let fontFace = "";
export let headerImage = "";
export let titleColor = "";
export let descriptionColor = "";
export let title = "";
export let description = "";
export let buttonBackground = "";
export let successButtonColor = "";
export let successButtonText = "";
export let backgroundImage = "none";
export let imageWrapperStyle = "width: 100%;";
export let imageWrapperImgStyle = "width: 100%;";
export let buttonBorderRadius = "20px";
export let onButtonClick = () => { };
</script>

<div
  class="result-card"
  style={`
    background: ${backgroundColor};
    background-image: url(${backgroundImage});
    background-repeat:no-repeat;
    background-position: center;
    background-size: cover;
  `}
>
  <div class="image-wrapper" style={imageWrapperStyle}>
    {#if headerImage}
      <img src={headerImage} alt="success" style={imageWrapperImgStyle}/>
    {:else}
      <div style="padding: 5vh;"></div>
    {/if}
  </div>
  <h5
    class="title"
    style={`
      font-family: ${fontFace};
      color: ${titleColor};
      font-size: 30px;
      margin: 10px 0 8px 0;
      padding: 0;
      text-align: center;
      font-weight: bold;
    `}
  >
    {title}
  </h5>
  <div
    class="description"
    style={`
      font-family: ${fontFace};
      color: ${descriptionColor};
      font-size: 16px;
      text-align: center;
      margin: 0 0 8px 0;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 8px;
    `}
  >
    {description}
  </div>
  <div class="button-wrapper">
    <a
      class="link"
      style={`
        font-family: ${fontFace};
        background: ${buttonBackground};
        color: ${successButtonColor};
        display: flex;
        height: 48px;
        align-items: center;
        justify-content: center;
        border-radius: ${buttonBorderRadius};
        text-align: center;
        font-weight: bold;
        font-size: 18px;
      `}
      on:click={() => onButtonClick()}
    >
      {successButtonText}
    </a>
  </div>
</div>

<style type="text/css">*,
  *:before,
  *:after {
  box-sizing: border-box;
}

.result-card {
  padding: 30px 22px 30px 22px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 40px;
  width: 325px;
}

.image-wrapper {
  width: 100%;
}

.image-wrapper img {
  width: 100%;
}</style>
